"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.privaliaTheme = void 0;
var default_1 = __importDefault(require("./default"));
// tslint:disable:object-literal-sort-keys
exports.privaliaTheme = __assign(__assign({}, default_1.default), { name: 'privalia', typography: __assign(__assign({}, default_1.default.typography), { display: {
            small: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1rem',
                lineHeight: 'normal'
            },
            medium: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1rem',
                lineHeight: 'normal'
            },
            large: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 500,
                fontSize: '1.625rem',
                lineHeight: '48px'
            },
            x_large: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 500,
                fontSize: '1.625rem',
                lineHeight: '50px'
            }
        } }), colors: __assign(__assign({}, default_1.default.colors), { main: {
            base: '#000000',
            tap: '#464650',
            hover: '#22222B',
            focus: 'rgba(0,0,0,0.40)'
        }, accent: {
            base: '#e55253'
        }, text: __assign(__assign({}, default_1.default.colors.text), { title: '#000000' }), discount: __assign(__assign({}, default_1.default.colors.discount), { base: default_1.default.colors.red.s75, premium: default_1.default.colors.gold.s50 }) }), overrides: {
        price: {
            colors: {
                unavailable: {
                    primary: '#7b7b7f',
                    secondary: '#a2a2a7'
                }
            }
        }
    } });
// tslint:enable:object-literal-sort-keys
exports.default = exports.privaliaTheme;
